import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import {
	getUser
} from '@/http/api/user'
// import { getVipCount } from '@/http/api/getApi'

import { productData } from '@/constant/productData'

Vue.use(Vuex)

// 根据用户VIP产品更新产品权限
const setProductVip = (vipUnitProducts) => {
	if (!(vipUnitProducts && vipUnitProducts.length)) return

	productData.forEach(item => {
		item.childer.forEach(p => {
			if (!p.notVip) {
				if (vipUnitProducts.some(vip => (vip.appId === p.appId && vip.status == 1))) {
					p.havePermission = true
				}
			}
		})
	})
}

// 更新产品权限- AI选刊：仅当 aixkPermission == 1 时有权限（0 或无值为无权限）
const setProductVipaixk = (aixkPermission) => {
	if (aixkPermission != 1) return
	for (const module of productData) {
		const product = module.childer.find(p => p.id === 22)
		if (product) {
			product.havePermission = true
		}
	}
}

// 更新产品权限- 疾病研究：仅当 jbyjPermission == 1 时有权限（0 或无值为无权限）
const setProductVipjbyj = (jbyjPermission) => {
	if (jbyjPermission != 1) return
	for (const module of productData) {
		const product = module.childer.find(p => p.id === 23)
		if (product) {
			product.havePermission = true
		}
	}
}

export default new Vuex.Store({
	state: {
		userInfo: null,
		showHeader: true, // 显示头部颜色
		vipCount: 0, // VIP使用次数限制
	},
	getters: {},
	mutations: {
		setUserInfo(state, data) {
			state.userInfo = data
		},
		setShowHeader(state, data) {
			state.showHeader = data
		},
		// setVipCount(state, data) {
		// 	state.vipCount = data
		// },
	},
	actions: {
		async fetchUserInfo({ commit, dispatch }) {
			try {
				const res = await getUser();
				commit('setUserInfo', res.data);
				// 更新产品VIP权限（只使用单位会员权限）
				setProductVip(res.data?.vipUnitProducts)
				setProductVipaixk(res.data?.aixkPermission)
				setProductVipjbyj(res.data?.jbyjPermission)
				// 获取VIP使用次数限制
				// dispatch('fetchVipCount')
			} catch (error) {
				// 获取失败时设置为空对象，防止路由守卫无限重试
				commit('setUserInfo', {});
				throw error;
			}
		},
		/* async fetchVipCount({ commit }) {
			try {
				const res = await getVipCount()
				commit('setVipCount', res.data || 0)
			} catch (error) {
				commit('setVipCount', 0)
			}
		} */
	},
	modules: {}
})